import { isEmpty } from 'lodash';
import { TEXT } from '../../../../constants';
import { removeEmptyEntries } from '../../../../utils';
import { itemContext } from '../../../../utils/reviewItem/itemContext';
import { isBusinessDomain } from '../../../../utils/business';
import withImpressions from '../withImpressions';
import { getPageComponentType, getPageElementVersion } from './utils';
import { EVENTS } from './constants';

/**
 * Impressions wrapper for components
 * @param {React.ComponentType} WrappedComponent - since we're using HOC reference, it can't be stateless
 * @param {string} classNameDomSelector
 * @return wrapped component
 * **/

const getBuyerTypeShown = (review, businessDomain) => {
    if (businessDomain && review.repeat_buyer && review.is_business) {
        return 'repeat_buyer_and_pro';
    }

    if (businessDomain && review.is_business) {
        return 'pro';
    }

    if (review.repeat_buyer) {
        return 'repeat_buyer';
    }

    return null;
};

export const withConfiguredImpressions = (WrappedComponent, classNameDomSelector) =>
    withImpressions(WrappedComponent, {
        DOMSelector: `.${classNameDomSelector}`,
        getImpressionData: (
            data,
            { review, position, filters, filterType, displayPriceRange, displayOrderDuration }
        ) => {
            const businessDomain = isBusinessDomain();
            const output = {
                type: EVENTS.BigQuery,
                page: {
                    element: {
                        position,
                        name: 'buyer_review',
                        type: TEXT,
                        score: review.value,
                        metadata: review.reviewer_country_code,
                        version: getPageElementVersion(review.changed_position),
                    },
                    component: {
                        name: 'review',
                        num_of_elements: review.reviews_count_as_buyer,
                        type: getPageComponentType(review.is_cancelled_order),
                    },
                },
                order: {
                    encrypted_id: review.encrypted_order_id,
                },
                item_context: {
                    type: itemContext({
                        isBusiness: review.is_business,
                    }),
                },
                ratings: {
                    order_duration_shown: displayOrderDuration ? review.order_duration_en : null,
                    order_price_range_shown: displayPriceRange ? review.order_price_range_usd : null,
                    buyer_type_shown: getBuyerTypeShown(review, businessDomain),
                },
            };

            const componentMetadata = removeEmptyEntries({ filters, filterType });

            if (!isEmpty(componentMetadata)) {
                output.page.component.metadata = JSON.stringify(componentMetadata);
            }

            return output;
        },
    });
